import React, { useEffect, useState } from 'react';
import { Image, Label, Layer, Stage, Rect, Tag, Text } from 'react-konva';
import { Api } from "../../../helpers/Api";
import { SketchPicker } from "react-color";
import Select from "react-select";
import png from "./Qrcode_wikipedia.jpg"
import { Remove } from '@mui/icons-material';

let loading = false;
const TemplateBuilder = ({ qrCode, setQrCode, templateTexts, setTemplateTexts, labels, setLabels, images, setImages, backgroundImageUrl, setBackgroundImageUrl, Index }) => {

    const [backgroundImage, setBackgroundImage] = useState(null);
    const [imageMaps, setImageMaps] = useState({});
    const [selectedLabelIndex, setSelectedLabelIndex] = useState(-1);
    const [selectedTextIndex, setSelectedTextIndex] = useState(-1);
    const [selectedImageIndex, setSelectedImageIndex] = useState(-1);
    const [qrrCode, setQrrCode] = useState({ x: 20, y: 50, width: 70, height: 70 });
    const [qrImage, setQrImage] = useState(null);
    const [qrSizeLabel, setQrSizeLabel] = useState(false);
    const addLabel = (type = 'label') => {
        const label = {
            id: labels.length.toString(),
            x: 100,
            y: 100,
            width: 100,
            draggable: true,
            text: `Label`,
            fontSize: 20,
            align: 'left',
            lineHeight: 1.2,
            fontFamily: 'Arial',
            padding: 10,
            color: '#000000'
        };
        setLabels([...labels, label]);
    }

    const addText = (type = 'Text') => {
        const label = {
            id: templateTexts.length.toString(),
            x: 100,
            y: 100,
            width: 100,
            draggable: true,
            text: `text`,
            fontSize: 20,
            align: 'left',
            lineHeight: 1.2,
            fontFamily: 'Arial',
            padding: 10,
            color: '#000000'
        };
        setTemplateTexts([...templateTexts, label]);
    }

    const addImage = (url) => {
        const label = {
            id: 'image-' + images.length.toString(),
            x: 100,
            y: 100,
            width: 170,
            height: 60,
            draggable: true,
            url: url,
            fontSize: 20,
            lineHeight: 1.2,
            padding: 10,
            color: '#000000'
        };
        setImages([...images, label]);
    }

    const handleDragStart = (e) => {
        const id = e.target.id();
        setLabels(
            labels.map((star) => {
                return {
                    ...star,
                    isDragging: star.id === id,
                };
            })
        );
    };

    const handleDragStartText = (e) => {
        const id = e.target.id();
        setTemplateTexts(
            templateTexts?.map((star) => {
                return {
                    ...star,
                    isDragging: star.id === id,
                };
            })
        );
    };

    const handleDragEndText = (e) => {
        setTemplateTexts(
            templateTexts?.map((star) => {
                return {
                    ...star,
                    isDragging: false,
                    ...{
                        x: e.target.id() === star.id ? e.target.x() : star.x,
                        y: e.target.id() === star.id ? e.target.y() : star.y,
                    }
                };
            })
        );
    };

    const handleDragStartImage = (e) => {
        const id = e.target.id();
        setImages(
            images.map((star) => {
                return {
                    ...star,
                    isDragging: star.id === id,
                };
            })
        );
    };

    const handelDragEndqrCode = (e) => {
        if (qrCode) {
            setQrCode({ ...qrCode, x: e.target.x(), y: e.target.y() })
        }
        else {
            setQrCode({ ...qrrCode, x: e.target.x(), y: e.target.y() })
        }
    };

    const Remove = (index) =>{
        setSelectedLabelIndex(-1);
         let l =[...labels];
         l.splice(index, 1);
         setLabels(l);
    }

    const RemoveText = (index) =>{
        setSelectedTextIndex(-1);
         let l =[...templateTexts];
         l.splice(index, 1);
         setTemplateTexts(l);
    }

    const handleDragEnd = (e) => {
        setLabels(
            labels.map((star) => {
                return {
                    ...star,
                    isDragging: false,
                    ...{
                        x: e.target.id() === star.id ? e.target.x() : star.x,
                        y: e.target.id() === star.id ? e.target.y() : star.y,
                    }
                };
            })
        );
    };

    const handleDragEndImage = (e) => {
        setImages(
            images.map((star) => {
                return {
                    ...star,
                    isDragging: false,
                    ...{
                        x: e.target.id() === star.id ? e.target.x() : star.x,
                        y: e.target.id() === star.id ? e.target.y() : star.y,
                    }
                };
            })
        );
    };

    // const handelDragEndqrCode = (e) => {
    //     setQrCode({...qrCode, x: e.target.x(), y: e.target.y()})
    //     console.log(qrCode);
    // };

    const handImageLoad = (e) => {
        setBackgroundImage(e.target)
    }
    useEffect(() => {
        if (backgroundImageUrl) {
            const image = new window.Image();
            backgroundImageUrl = backgroundImageUrl.replace("itmatic.io","codebrigade.in");
            image.src = backgroundImageUrl;

            image.addEventListener('load', handImageLoad);
            return () => {
                image.removeEventListener('load', handImageLoad)
            };
        }
    }, [backgroundImageUrl]);

    useEffect(() => {
        images.forEach(({ url }, index) => {
            const image = new window.Image();
            url = url.replace("itmatic.io","codebrigade.in");
            image.src = url;
            image.addEventListener('load', (e) => {
                setImageMaps(i => ({ ...i, [index]: e.target }))
            });
        })
    }, [images]);

    useEffect(()=>{
        const image = new window.Image();
        image.src = `${png}`;
        image.addEventListener('load',(e)=>{
            setQrImage(e.target); 
        });
        
        if(!qrCode.width && !qrCode.height){
            setQrCode({...qrCode,width:70, height:70});
        }
        
    },[qrCode])

    const triggerFileClick = () => {
        document.getElementById("backgroundImageFile" + Index).click();

    }

    const triggerImageFileClick = () => {
        document.getElementById("imageFile" + Index).click();
    }

    const onBackgroundImageSelect = (file) => {
        
        document.getElementById("backgroundImageFile" + Index).value = '';

        const formData = new FormData();

        formData.append('files', file);
        loading = true;
        Api.uploadFile(formData).then(response => {
            setBackgroundImageUrl(`${Api.base_url}${response[0].url}`)
        }).finally(loading = false );
    };

    const onImageSelect = (file) => {

        document.getElementById("backgroundImageFile" + Index).value = '';

        const formData = new FormData();

        formData.append('files', file);

        Api.uploadFile(formData).then(response => {
            addImage(`${Api.base_url}${response[0].url}`)
        });
    };

    return (
        <div className='mt-3 template-inner-box'>
            <div className='template-boxes'>
                <div className="template-image-box">
                    <input type="file" id={`backgroundImageFile${Index}`} onChange={e => {
                        onBackgroundImageSelect(e.target.files[0])
                    }} accept="image/*" style={{ display: 'none' }} />
                    <input type="file" id={`imageFile${Index}`} onChange={e => {
                        onImageSelect(e.target.files[0])
                    }} accept="image/*" style={{ display: 'none' }} />
                    <div className='template-view'>
                        <Stage width={650} height={450}>
                            <Layer>
                                <Image image={backgroundImage} width={650} height={450} />
                            </Layer>
                            <Layer>
                                <Label
                                    x={qrCode?.x ? qrCode.x : qrrCode.x}
                                    y={qrCode?.y ? qrCode.y : qrrCode.y}
                                    width={qrCode?.width ? qrCode.width : qrrCode.width}
                                    height={qrCode?.height ? qrCode.height : qrrCode.height}
                                    draggable
                                    onDragEnd={handelDragEndqrCode}
                                >
                                    <Image
                                        text='QR'
                                        onClick={e=>{
                                            setSelectedImageIndex(-1)
                                            setSelectedTextIndex(-1);
                                            setSelectedLabelIndex(-1)
                                            setQrSizeLabel(true);
                                        }}
                                        image={qrImage}
                                        width={qrCode?.width ? qrCode.width : qrrCode.width}
                                        height={qrCode?.height ? qrCode.height : qrrCode.height}
                                        shadowBlur={5} />
                                    {/* <Text text="   QR Place" /> */}
                                </Label>
                            </Layer>
                            
                            <Layer>
                                {images?.map((star, index) => (
                                   <Image
                                        id={star.id}
                                        key={star.key}
                                        x={star.x}
                                        y={star.y}
                                        width={star.width}
                                        height={star.height}
                                        image={imageMaps[index]}
                                        opacity={1}
                                        draggable
                                        onClick={e => {
                                            setSelectedImageIndex(index);
                                            setSelectedTextIndex(-1);
                                            setSelectedLabelIndex(-1)
                                            setQrSizeLabel(false);
                                        }}
                                        rotation={star.rotation}
                                        onDragStart={handleDragStartImage}
                                        onDragEnd={handleDragEndImage}
                                    >
                                    </Image>
                               ))}
                            </Layer> 
                            
                            <Layer>
                            {labels?.map((star, index) => (
                                <Label
                                    id={star.id}
                                    key={star.key}
                                    x={star.x}
                                    y={star.y}
                                    align={star?.align}
                                    width={star.width}
                                    opacity={1}
                                    draggable
                                    onClick={e => {
                                        setSelectedLabelIndex(index);
                                        setSelectedTextIndex(-1);
                                        setSelectedImageIndex(-1)
                                        setQrSizeLabel(false);
                                    }}
                                    
                                    rotation={star.rotation}
                                    onDragStart={handleDragStart}
                                    onDragEnd={handleDragEnd}
                                >
                                    {selectedLabelIndex === index &&
                                        <Tag strokeWidth={1} // border width
                                            stroke="green" />
                                    }
                                    <Text align={star?.align} width={star?.width} marginFill='black' text={star.text} fill={star.color} fontFamily={star.fontFamily||"Arial"}
                                        fontSize={Number(star.fontSize)}
                                        style={{ color: '#ffffff' }} />
                                </Label>
                            ))}
                            </Layer> 

                            <Layer>               
                            {templateTexts?.map((star, index) => (
                                <Label
                                    id={star.id}
                                    key={star.key}
                                    x={star.x}
                                    y={star.y}
                                    align={star?.align}
                                    width={star.width}
                                    opacity={1}
                                    draggable
                                    onClick={e => {
                                        setSelectedTextIndex(index);
                                        setSelectedLabelIndex(-1);
                                        setSelectedImageIndex(-1)
                                        setQrSizeLabel(false);
                                    }}
                                    
                                    rotation={star.rotation}
                                    onDragStart={handleDragStartText}
                                    onDragEnd={handleDragEndText}
                                >
                                    {selectedTextIndex === index &&
                                        <Tag strokeWidth={1} // border width
                                            stroke="green" />
                                    }
                                    <Text align={star?.align} width={star?.width} marginFill='black' text={star.text} fill={star.color} fontFamily={star.fontFamily||"Arial"}
                                        fontSize={Number(star.fontSize)}
                                        style={{ color: '#ffffff' }} />
                                </Label>
                            ))}
                            </Layer>
                        </Stage>
                    </div>
                </div>
                {selectedLabelIndex > -1 &&
                    <LabelProperties Remove={Remove} index={selectedLabelIndex} label={labels[selectedLabelIndex]} onChange={(v) => {
                        setLabels(labels.map((label) => {
                            if (label.id === v.id) {
                                return v;
                            }
                            return label;
                        }))
                    }} />
                }
                {selectedTextIndex > -1 &&
                    <LabelProperties Remove={RemoveText} index={selectedTextIndex} label={templateTexts[selectedTextIndex]} onChange={(v) => {
                        setTemplateTexts(templateTexts.map((label) => {
                            if (label.id === v.id) {
                                return v;
                            }
                            return label;
                        }))
                    }} />
                }
                {selectedImageIndex > -1 &&
                    <ImageProperties image={images[selectedImageIndex]} onChange={(v) => {
                        setImages(images.map((label) => {
                            if (label.id === v.id) {
                                return v;
                            }
                            return label;
                        }))
                    }} />
                }
                {qrSizeLabel && <QrLable qrCode={qrCode} setQrCode={setQrCode} />}
            </div>
            <button type="button" className='button' onClick={triggerFileClick}>{loading ? 'Please Wait' : 'Browse Template Design'}</button>
            <button type="button" className='button' onClick={triggerImageFileClick}>Add Signature</button>
            <button type="button" className='button' onClick={addLabel}>Add Label</button>
            <button type="button" className='button' onClick={addText}>Add Text</button>
            <div style={{visibility:"hidden"}}>
            <p style={{ color:"#DF0101", fontFamily:"DancingScript" }} >DancingScript</p>
            <p style={{ color:"#DF0101", fontFamily:"Engagement" }} >Engagement</p>
            <p style={{ color:"#DF0101", fontFamily:"Caveat" }} >Caveat</p>
            <p style={{ color:"#DF0101", fontFamily:"Calibri" }} >Calibri</p>
            <p style={{ color:"#DF0101", fontFamily:"BookAntiqua" }} >BookAntiqua</p>
            <p style={{ color:"#DF0101", fontFamily:"Times" }} >Times</p>
            </div>
        </div>
    );
};

const QrLable = ({qrCode,setQrCode}) =>{
    console.log(qrCode);
    return <div className='template-right'>
       <div className="picker-label">
            <span>Qr Width:</span>
            <input type="number" value={Number(qrCode.width)}  onChange={(e) => {
                setQrCode({...qrCode,width:e.target.value})
            }} />
        </div>
        <div className="picker-label">
            <span>Qr Height:</span>
            <input type="number" value={Number(qrCode.height)} onChange={(e) => {
                setQrCode({...qrCode,height:e.target.value})
            }} />
        </div>
    </div>
}

const LabelProperties = ({ label,index, onChange, Remove }) => {
    console.log(label);
    return <div className='template-right'>
       <div className="picker-label1"> 
            <button className='button' onClick={()=>{Remove(index)}} >Remove label</button>
       </div>
        <div className="picker-label1">
            <span>Alignment:</span>
            <Select options={[{ label: "left", value: "left" },{ label: "center", value: "center" },{ label: "right", value: "right" }]} isMulti={false}
             defaultValue={label.align} onChange={(e) => {
            onChange({ ...label, align: e.value })
            }} />
        </div>
        <div className="picker-label">
            <span>Label:</span>
            <input value={label.text} onChange={(e) => {
                onChange({ ...label, text: e.target.value })
            }} />
        </div>
        <div className="picker-label">
            <span>Color:</span>
            <ColorPicker value={label.color} onChange={(color) => {
                onChange({ ...label, color })
            }} />
        </div>
        <div className="picker-label">
            <span>Length of label:</span>
            <input type="number" value={label.width} onChange={(e) => {
                onChange({ ...label, width: e.target.value })
            }} />
        </div>
        <div className="picker-label">
            <span>Font Size:</span>
            <input type="number" value={label.fontSize} onChange={(e) => {
                onChange({ ...label, fontSize: e.target.value })
            }} />
        </div>
        <div className="picker-label1">
            <span>Font Family:</span>
            <Select options={[{ label: "Arial", value: "Arial" },
                              { label: "Engagement", value: "Engagement" },
                              { label: "DancingScript", value: "DancingScript" },
                              { label: "Caveat", value: "Caveat" },
                              { label: "Tahoma", value: "Tahoma" },
                              { label: "Times New Roman", value: "Times New Roman" },
                              { label: "Calibri", value: "Calibri" },
                              { label: "BookAntiqua", value: "BookAntiqua" },
                              { label: "Times", value: "Times" },
                            ]} 
                              isMulti={false}
                defaultValue={{ label: (label.fontFamily || "Arial"), value: (label.fontFamily || "Arial") }}
                onChange={(o) => {
                    onChange({ ...label, fontFamily: o.value })
                }} />
        </div>

    </div>
}
const ImageProperties = ({ image, onChange }) => {
    return <div className='template-right'>
        <div className="picker-label">
            <span>Width:</span>
            <input type="number" value={image.width || 100} onChange={(e) => {
                onChange({ ...image, width: e.target.value })
            }} />
        </div>
        <div className="picker-label">
            <span>Height:</span>
            <input type="number" value={image.height || 100} onChange={(e) => {
                onChange({ ...image, height: e.target.value })
            }} />
        </div>
    </div>
}

const ColorPicker = ({ value, onChange }) => {
    const [show, setShow] = useState(false);
    if (!show) {
        return <div style={{ width: 50, height: 50, cursor: 'pointer', backgroundColor: value }}
            onClick={() => setShow(true)} />
    }
    if (show) {
        return <SketchPicker
            color={value}
            onChangeComplete={c => {
                setShow(false)
                onChange(c.hex)
            }}
        />
    }
}
export default TemplateBuilder;
